import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import Logo from './Logo';
import UserMenu from './UserMenu';

/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/apps/UserDashboard.js (Header 부분)
 * Ant Design Header + Menu → TailwindCSS 커스텀 헤더
 */

interface NavItem {
  key: string;
  label: string;
  path: string;
}

const NAV_ITEMS: NavItem[] = [
  { key: 'my-campaigns', label: 'Dashboard', path: '/bridge/my_campaigns' },
  { key: 'campaigns', label: 'Campaigns', path: '/bridge/campaigns' },
  { key: 'profile', label: 'Profile', path: '/bridge/profile' },
];

// /bridge/* 경로 → 신규 경로 키 매핑 (원본 gc-zoku 호환)
const BRIDGE_PATH_MAP: Record<string, string> = {
  '/bridge/my_campaigns': 'my-campaigns',
  '/bridge/campaigns': 'campaigns',
  '/bridge/profile': 'profile',
};

function Header() {
  const location = useLocation();
  const currentUser = useAppSelector((s) => s.envs.currentUser);

  const activeKey =
    NAV_ITEMS.find((item) =>
      location.pathname === item.path || location.pathname.startsWith(item.path + '/'),
    )?.key ??
    Object.entries(BRIDGE_PATH_MAP).find(([bridgePath]) =>
      location.pathname === bridgePath || location.pathname.startsWith(bridgePath + '/'),
    )?.[1];

  return (
    <header className="bg-black h-16 flex items-center px-6 shadow-md sticky top-0 z-50">
      <Logo />

      {currentUser && (
        <nav className="hidden sm:flex items-center gap-1 flex-1 ml-10">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.key}
              to={item.path}
              className={`px-4 py-2 text-lg font-medium uppercase ${
                activeKey === item.key
                  ? 'text-white font-semibold border-b-2 border-white'
                  : 'text-gray-300 hover:text-white hover:border-b-2 hover:border-white/10'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}

      <div className="ml-auto">
        <UserMenu user={currentUser} />
      </div>
    </header>
  );
}

export default Header;
